import { render, staticRenderFns } from "./AddHotSpot.vue?vue&type=template&id=6cd82d3c&scoped=true"
import script from "./AddHotSpot.vue?vue&type=script&lang=js"
export * from "./AddHotSpot.vue?vue&type=script&lang=js"
import style0 from "./AddHotSpot.vue?vue&type=style&index=0&id=6cd82d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd82d3c",
  null
  
)

export default component.exports